document.addEventListener('DOMContentLoaded', function () {
  const ajaxUrl   = window.skepkaAjax?.url       || '/wp-admin/admin-ajax.php';
  const thanksUrl = window.skepkaAjax?.thanksUrl || '/thanks/';

  // Формы, которые нужно перехватить
  const forms = document.querySelectorAll('#modalForm, #calculationForm');

  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Собираем данные
      const formData = new FormData();
      formData.append('action', 'skepka_submit_form');

      const nameInput  = form.querySelector('input[type="text"]');
      const phoneInput = form.querySelector('input[type="tel"]');
      const textarea   = form.querySelector('textarea');
      const fileInput  = form.querySelector('input[type="file"]');

      if (nameInput)  formData.append('name',    nameInput.value.trim());
      if (phoneInput) formData.append('phone',   phoneInput.value.trim());
      if (textarea)   formData.append('message', textarea.value.trim());

      // Чекбоксы способов связи
      form.querySelectorAll('input[name="contact[]"]:checked').forEach(function (cb) {
        formData.append('contact[]', cb.value);
      });

      // Файлы
      if (fileInput && fileInput.files) {
        for (let i = 0; i < fileInput.files.length; i++) {
          formData.append('files[]', fileInput.files[i]);
        }
      }

      // Источник формы
      const source = form.id === 'modalForm' ? 'Модальное окно' : 'Блок расчёта';
      formData.append('form_source', source);

      // Блокируем кнопку
      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.dataset.originalText = submitBtn.textContent;
        submitBtn.textContent = 'Отправка...';
      }

      // Отправка
      fetch(ajaxUrl, { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.success) {
            window.location.href = thanksUrl;
          } else {
            alert((res.data && res.data.message) || 'Ошибка');
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitBtn.dataset.originalText || 'Получить оценку';
            }
          }
        })
        .catch(function () {
          alert('Ошибка сети, попробуйте позже');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.dataset.originalText || 'Получить оценку';
          }
        });
    });
  });
});
